/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  TIME_TO_FIRST_FRAME_FETCHING,
  TIME_TO_FIRST_FRAME_FETCHING_DONE,
  TIME_TO_FIRST_FRAME_FETCHING_ERROR,
  ITimeToFirstFrameActionType
} from 'store/action';
import {ITimeToFirstFrameCluster} from 'interfaces';
import {IPortalError} from 'utility/error-handler';

export interface ITimeToFirstFrameState {
  isFetching: boolean;
  error: null | IPortalError;
  timeToFirstFrame: ITimeToFirstFrameCluster;
}

const defaultState = {
  isFetching: false,
  error: null,
  timeToFirstFrame: null
};
const timeToFirstFrameReducer: Reducer<Readonly<ITimeToFirstFrameState>, ITimeToFirstFrameActionType> = (
  state: ITimeToFirstFrameState = defaultState,
  action: ITimeToFirstFrameActionType
) => {
  switch (action.type) {
    case TIME_TO_FIRST_FRAME_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case TIME_TO_FIRST_FRAME_FETCHING_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        timeToFirstFrame: action.payload.data
      };
    }

    case TIME_TO_FIRST_FRAME_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default timeToFirstFrameReducer;